// Override
var GetChildrenHeight = function () {
    return 0;
}

export default GetChildrenHeight;